<template>
  <div
    class="gap-4 flex"
    :class="{
      'flex-col': isVertical,
      'flex-row': isHorizontal
    }"
  >
    <img
      v-for="n in 3"
      :key="`star-${n}`"
      :class="{ grayscale: n > displayedValue }"
      :style="`height: ${size}px; width: ${size}px`"
      src="/icons/star.png"
    />
  </div>
</template>

<script>
export default {
  name: 'HubTopicsListItemStars',

  props: {
    value: { type: Number, default: 0 },
    isVertical: { type: Boolean, default: true },
    size: { type: Number, default: 24 }
  },

  data() {
    return {
      displayedValue: 0
    }
  },

  computed: {
    isHorizontal() {
      return !this.isVertical
    }
  },

  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        this.displayedValue = 0
        for (let i = 1; i <= newValue; i++) {
          setTimeout(() => {
            this.displayedValue = i
          }, i * 300)
        }
      }
    }
  }
}
</script>

<style scoped>
img {
  transition: filter 0.3s ease, transform 0.3s ease;
  transform: scale(0.9);
}
img:not(.grayscale) {
  transform: scale(1);
}
.grayscale {
  filter: grayscale(1);
}
</style>
